import React, { ReactNode, useState } from 'react';
import { classNames } from '../../utils/style';
import { VideoThumbnail } from '../../components/Video/VideoThumbnail';
import { ModalVideoContent } from './ModalVideoContent';
import { VideoModalContext } from './VideoModalContext';
import { ImageProps } from '../../components/Image/types';

export interface VideoModalProps {
  gradient?: boolean;
  logo?: ImageProps;
  image?: ImageProps;
  VideoPlayer?: ReactNode;
  ShortVideo?: ReactNode;
  ctaLightboxTitle?: string;
  ctaButtonLightbox?: ReactNode;
  ratio?: 'video' | 'vertical' | 'square' | '4/3' | '3/4';
  className?: string;
  classnameThumbnail?: string;
  classnameBoxThumbnail?: string;
  onClick?: any;
}

export const VideoModal = ({
  gradient = true,
  logo,
  image,
  VideoPlayer,
  ShortVideo,
  onClick,
  ctaLightboxTitle,
  ctaButtonLightbox,
  className,
  ratio = 'video',
  classnameThumbnail,
  classnameBoxThumbnail,
}: VideoModalProps) => {
  const [showVideo, setShowVideo] = useState(false);

  const toggleVideo = (e: any) => {
    if (onClick) {
      onClick(e);
    }
    setShowVideo(!showVideo);
  };

  return (
    <VideoModalContext.Provider
      value={{
        toggleVideo,
        showVideo,
        ctaLightboxTitle,
        ctaButtonLightbox,
        VideoPlayer,
        ratio,
      }}
    >
      <div className={classNames('VideoModal', className)}>
        <VideoThumbnail
          toggleVideo={toggleVideo}
          ShortVideo={ShortVideo}
          image={image}
          gradient={gradient}
          logo={logo}
          classnameThumbnail={classnameThumbnail}
          classnameBoxThumbnail={classnameBoxThumbnail}
        />
        <ModalVideoContent />
      </div>
    </VideoModalContext.Provider>
  );
};
